export enum CloseOutType {
  MANUAL = 'MANUAL',
  AUTO = 'AUTO',
}
